import styled from 'styled-components'

import { Link as BaseLink } from '@redriverpress/system'

const Link = styled(BaseLink).attrs(props => ({
  fontWeight: 600,
  display: props.display || 'inline-block',
}))`
  text-decoration-color: ${props => props.theme.colors.blue700};
`

Link.defaultProps = {
  color: 'black',
}

export default Link
